import { render, staticRenderFns } from "./UserType.vue?vue&type=template&id=070f0a57"
import script from "./UserType.vue?vue&type=script&lang=js"
export * from "./UserType.vue?vue&type=script&lang=js"
import style0 from "./UserType.vue?vue&type=style&index=0&id=070f0a57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports